import appbase from 'hobbit-base/components/appbase/index.vue';
import faqimbtn from '../components/faqimbtn/faqimbtn.vue';

export default {
  name: 'app',
  data() {
    return {
      faqIMBtnEnable: false,
    };
  },
  computed: {
    disableIMRoutes() {
      return (
        this.$config.custom.disableIMRoutes[this.$ctx.vt]
        || this.$config.custom.disableIMRoutes.pc
      );
    },
  },
  methods: {
    route(to, from) {
      // 指定路由或App中禁用IM
      this.faqIMBtnEnable = (to.name && !this.disableIMRoutes.includes(to.name))
        && ![this.$ctx.CLIENT.VKIOS, this.$ctx.CLIENT.VKANDROID].includes(this.$ctx.client);
    },
    /**
     * SPA跳转增加语言码追加逻辑，即本站内跳转自动追加语言目录
     */
    beforePageTo(to, ani, replace, open, transferData, isCross) {
      if (typeof to === 'string' && !this.$ctx.getLangByPath(to)) {
        const toWithLang = `/${this.$ctx.lang}${to}`;
        isCross = this.$app.isCrossAppRoute(toWithLang);
        if (!isCross) {
          to = toWithLang;
        }
      }

      return {
        to,
        ani,
        replace,
        open,
        transferData,
        isCross,
      };
    },
  },
  components: {
    appbase,
    faqimbtn,
  },
};
